import React from "react";
import { connect } from "react-redux";
import { exportReportPDF } from "../Actions/ReportsAPI";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import swal from "sweetalert";
import Moment from "moment";
import DatePicker from "react-datepicker";
import { getRevisionHistory, getShipDetail } from "../Actions/ShipViewAPI";
import {
  DownloadDocument,
  UploadDocument,
  UploadLRDocument,
  UploadDocuments,
  UploadRevisionDocument,
  UploadLRFROMDocument,
  getAttachments,
  deleteImages,
  UploadDocumentsPDF,
  getAttachmentsPDF,
} from "../Actions/CommonAPI";
import Lightbox from "../lib";
import { confirmAlert } from "react-confirm-alert";
import { showLoader } from "../Actions/PageLoaderAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import {
  getPaintCoating,
  getEquipmentMachinery,
  getStructureAndHull,
  getStores,
  getLRForm,
  getLRFormPDF,
} from "../Actions/ShipManagementAPI";
import { getIHMFullManual } from "../Actions/ShipViewAPI";
import Swal from "sweetalert2";

let user1 = localStorage.getItem("UserRoles");

class IHMMaintenanceRevision extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      isFile: false,
      isInventory: false,
      isLR: false,
      isIHMReport: false,
      RevisionUpdate: {
        attachmentName: "",
        attachmentGuid: "",
        shipId: "",
        attachmentsName: [],
        attachmentsGuid: [],
      },
      LRFromUpdate: {
        attachmentName: "",
        attachmentGuid: "",
        shipId: "",
      },
      searchData: {
        vesselname: "",
        minyear: "",
        maxyear: "",
      },
      isAll: true,
      file: "",
      files: "",
      LRfile: "",
      multifiles: [],
      filesPDF: "",
      multifilesPDF: [],
      paintAndCoating: [],
      equipmentAndMachinery: [],
      structureAndHull: [],
      store: [],
      activePagePaintCoating: 0,
      activePageEquipment: 0,
      activePageStructure: 0,
      activePageStore: 0,
      rows: 5,
      isFromOpen: false,
      isToOpen: false,
    };
  }

  handleFromToChange(date, fieldName) {
    const formatted = Moment(date).format("YYYY-MM-DD");

    this.setState((prev) => ({
      searchData: {
        ...prev.searchData,
        [fieldName]: formatted,
      },
      isFromOpen: false,
      isToOpen: false,
    }));
  }

  isAllCheck = (e) => {
    this.setState({
      searchData: {
        ...this.state.searchData,
        minyear: "",
        maxyear: "",
      },
    });
    this.setState({ isAll: e.target.checked });
  };

  componentDidMount() {
    const { dispatch, match, IHMFullManual, ShipDetail } = this.props;

    const { params } = match;
    const { id } = params;
    let user = JSON.parse(localStorage.getItem("revisionId"));
    let shipId = JSON.parse(localStorage.getItem("shipId"));
    dispatch(getIHMFullManual(IHMFullManual?.ihmPart1?.shipId || id || shipId));
    if (user !== "" || user !== null) {
      dispatch(getRevisionHistory(user));
    } else {
      dispatch({ type: "getRevisionHistorySuccess", data: [] });
    }
    if (id) {
      dispatch({ type: "getAttachmentsSuccess", data: null });
      dispatch(getAttachments(id));
      dispatch(getShipDetail(id));
      dispatch(getPaintCoating(id));
      dispatch(getEquipmentMachinery(id));
      dispatch(getStructureAndHull(id));
      dispatch(getStores(id));
      dispatch(getAttachmentsPDF(id));
      dispatch(getLRForm(id, true));
    } else {
      dispatch({ type: "getAttachmentsSuccess", data: null });
      dispatch(getAttachments(shipId));
      dispatch(getShipDetail(shipId));
      dispatch(getPaintCoating(shipId));
      dispatch(getEquipmentMachinery(shipId));
      dispatch(getStructureAndHull(shipId));
      dispatch(getStores(shipId));
      dispatch(getAttachmentsPDF(shipId));
      dispatch(getLRForm(shipId, true));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { attachmentDetail, attachmentsDetail, attachmentLRDetail } =
      nextProps;
    if (attachmentDetail) {
      prevState.RevisionUpdate.attachmentName = attachmentDetail.FileName;
      prevState.RevisionUpdate.attachmentGuid = attachmentDetail.Guid;
      prevState.file = "";
    }
    if (attachmentsDetail) {
      prevState.RevisionUpdate.attachmentsName = attachmentsDetail.FileName;
      prevState.RevisionUpdate.attachmentsGuid = attachmentsDetail.Guid;
      /*  prevState.LRfile = '' */
    }
    if (attachmentLRDetail) {
      prevState.LRFromUpdate.attachmentName = attachmentLRDetail.FileName;
      prevState.LRFromUpdate.attachmentGuid = attachmentLRDetail.Guid;
      prevState.LRfile = "";
    }
    return {
      paintAndCoating: nextProps.paintCoating,
      equipmentAndMachinery: nextProps.equipmentMachinery,
      structureAndHull: nextProps.structureAndHull,
      store: nextProps.store,
    };
    // if (getAttachmentsDetail) {
    //     prevState.images = getAttachmentsDetail;
    // }
    // if (nextProps.isMDSearch) {
    //     // prevState.searchDate = nextProps.MDSearchData;
    // }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      this.state.RevisionUpdate.attachmentName = e.target.files[0].name;
      this.state.file = e.target.files[0];
      this.setState({ RevisionUpdate: this.state.RevisionUpdate });
      this.props.dispatch(UploadDocument(e.target.files[0]));
    }
    if (nodeName === "LrfileName") {
      this.state.LRFromUpdate.attachmentName = e.target.files[0].name;
      this.state.LRfile = e.target.files[0];
      this.setState({ LRFromUpdate: this.state.LRFromUpdate });
      this.props.dispatch(UploadLRDocument(e.target.files[0]));
    }
  }

  fileSelectedHandler = (e) => {
    this.state.multifiles = [...e.target.files];
    let file = "";
    let multifile = [...e.target.files];
    multifile.map((i, index) => {
      if (index === 0) {
        file = i.name;
      } else {
        file = file + ", " + i.name;
      }
    });
    this.setState({ files: file });
  };

  fileSelectedHandlers = (e) => {
    this.state.multifilesPDF = [...e.target.files];
    let file = "";
    let multifile = [...e.target.files];
    multifile.map((i, index) => {
      if (index === 0) {
        file = i.name;
      } else {
        file = file + ", " + i.name;
      }
    });
    this.setState({ filesPDF: file });
  };

  ClearInput() {
    let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "AttachmentUploadSuccess",
      data: clearData,
    });
  }

  ClearLRInput() {
    let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "AttachmentLRUploadSuccess",
      data: clearData,
    });
  }
  ClearInputs() {
    // let clearData = { FileName: "", Guid: "" }
    // this.props.dispatch({
    //     type: "AttachmentsUploadSuccess",
    //     data: clearData,
    // });
    // this.state.files = '';
    this.setState({ files: "", multifiles: "" });
  }

  ClearInputsPDF() {
    // let clearData = { FileName: "", Guid: "" }
    // this.props.dispatch({
    //     type: "AttachmentsUploadSuccess",
    //     data: clearData,
    // });
    // this.state.files = '';
    this.setState({ filesPDF: "", multifilesPDF: "" });
  }

  UploadDocument() {
    let clearData = { FileName: "", Guid: "" };
    const { dispatch, match, IHMFullManual } = this.props;
    // const { params } = match;
    // const { id } = params;
    this.state.RevisionUpdate.shipId = IHMFullManual.ihmPart1.shipId;
    if (this.state.RevisionUpdate.attachmentName == "") {
      swal("Error!", "Upload Revision Document is empty", "warning");
    } else {
      dispatch(
        UploadRevisionDocument(
          this.state.RevisionUpdate,
          clearData,
          IHMFullManual.latestUpdated.revisionId,
          IHMFullManual.latestUpdated.shipId
        )
      );
    }
  }
  UploadLRFromDocument() {
    let clearData = { FileName: "", Guid: "" };
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    this.state.LRFromUpdate.shipId = id;
    let user = JSON.parse(localStorage.getItem("currentUser"));
    if (this.state.LRFromUpdate.attachmentName == "") {
      swal("Error!", "Upload LR From is empty", "warning");
    } else {
      dispatch(
        UploadLRFROMDocument(this.state.LRFromUpdate, clearData, user.email, id)
      );
    }
  }

  UploadDocuments() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    if (this.state.multifiles == "") {
      swal("Error!", "Document is empty", "warning");
    } else {
      dispatch(UploadDocuments(this.state.multifiles, id));
      this.setState({ files: "", multifiles: "" });
    }
  }

  UploadDocumentsPDF() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    if (this.state.multifilesPDF == "") {
      swal("Error!", "Document is empty", "warning");
    } else {
      dispatch(UploadDocumentsPDF(this.state.multifilesPDF, id));
      this.setState({ filesPDF: "", multifilesPDF: "" });
    }
  }

  DeleteDocuments(e) {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let img = [
              {
                isDeleted: true,
                attachmentId: e,
              },
            ];
            dispatch(deleteImages(img, id));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  downloadDocument = (attachmentDetail) => {
    const { dispatch } = this.props;
    dispatch(
      DownloadDocument(
        attachmentDetail.attachmentName,
        attachmentDetail.attachmentGuid
      )
    );
  };
  downloadLRFromDocument = (attachmentDetail) => {
    const { dispatch } = this.props;
    dispatch(
      DownloadDocument(
        attachmentDetail.attachmentName,
        attachmentDetail.attachmentGuid
      )
    );
  };
  downloadLRDocument = (attachmentDetail) => {
    debugger;
    const { dispatch } = this.props;
    dispatch(
      DownloadDocument(attachmentDetail.FileName, attachmentDetail.Guid)
    );
  };

  downloadRevisionDocument = (fileName, Guid) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(fileName, Guid));
  };

  deleteRevisionDocument = (item) => {
    const { dispatch, IHMFullManual } = this.props;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let data = {
              revisionId: item.revisionId,
            };
            let url = `${API.DeleteRevisionDocument}`;
            axios
              .post(url, data)
              .then((response) => {
                dispatch(getIHMFullManual(IHMFullManual.latestUpdated.shipId));
                dispatch({
                  type: "DeleteRevisionDocumentSuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteRevisionDocumentFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  DownloadReport(shipName) {
    const { dispatch } = this.props;
    if (this.state.isAll) {
      this.setState(
        {
          searchData: {
            vesselname: shipName,
            minyear: this.state.isAll
              ? ""
              : this.state.searchData.minyear ?? "",
            maxyear: this.state.isAll
              ? ""
              : this.state.searchData.maxyear ?? "",
          },
        },
        () => {
          dispatch(exportReportPDF(this.state.searchData));
        }
      );
    } else {
      if (
        this.state.searchData.minyear.trim() !== "" &&
        this.state.searchData.minyear !== null &&
        this.state.searchData.maxyear.trim() !== "" &&
        this.state.searchData.maxyear !== null
      ) {
        this.setState(
          {
            searchData: {
              vesselname: shipName,
              minyear: this.state.isAll
                ? ""
                : this.state.searchData.minyear ?? "",
              maxyear: this.state.isAll
                ? ""
                : this.state.searchData.maxyear ?? "",
            },
          },
          () => {
            dispatch(exportReportPDF(this.state.searchData));
          }
        );
      } else {
        swal("Error!", "From and To Date is mandatory", "warning");
      }
    }
  }

  toggleVisibility = () =>
    this.setState((prevState) => ({ isActive: !this.state.isActive }));
  toggleVisibiliti = () => {
    const { getAttachmentsDetail, dispatch } = this.props;
    if (getAttachmentsDetail === null) {
      dispatch(showLoader());
    }
    this.setState((prevState) => ({ isFile: !this.state.isFile }));
  };
  toggleVisibilities = () => {
    this.setState((prevState) => ({ isInventory: !this.state.isInventory }));
  };
  lrToggleVisibility = () => {
    this.setState((prevState) => ({ isLR: !this.state.isLR }));
  };
  IHMToggleVisibility = () => {
    this.setState((prevState) => ({ isIHMReport: !this.state.isIHMReport }));
  };

  render() {
    const {
      LRFormPDF,
      LRForm,
      IHMFullManual,
      getAttachmentsDetail,
      getAttachmentsPDFDetail,
      PaintCoating,
      EquipmentMachinery,
      StructureAndHull,
      Store,
      ShipDetail,
    } = this.props;

    return (
      <div className="full-height pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", marginBottom: 0 }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    IHM Part I Initial Full Manual
                  </h5>
                </div>
              </div>
              <div className="py-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-sm-12"}>
                      <div className="row mx-2 my-2">
                        <div className="col-sm-3">
                          <span>
                            <strong>Issue Date : </strong>
                            <span className="lato">
                              {IHMFullManual.ihmPart1
                                ? Moment(
                                    new Date(
                                      Date.parse(
                                        IHMFullManual.ihmPart1.issueDate
                                      )
                                    )
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-9">
                          <span>
                            <strong>Download : </strong>
                            <span class="italicFont ">
                              {IHMFullManual.ihmPart1
                                ? IHMFullManual.ihmPart1.attachmentName
                                : ""}
                              {IHMFullManual.ihmPart1 &&
                              IHMFullManual.ihmPart1.attachmentName ? (
                                <>
                                  <i
                                    class="fa fa-download click ml-2"
                                    onClick={() =>
                                      this.downloadDocument(
                                        IHMFullManual.ihmPart1
                                      )
                                    }
                                  ></i>
                                  <a
                                    href={IHMFullManual?.ihmPart1?.fileUrl}
                                    target="_blank"
                                    className="link-colors pl-2"
                                  >
                                    <i class="fa fa-eye click ml-1"></i>
                                  </a>
                                </>
                              ) : null}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.toggleVisibiliti}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {!this.state.isFile ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                      Location of Hazardous Materials
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                      <div className="row mb-2">
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-4">
                            <label className="form-label">Upload Img : </label>
                            <br></br>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  Browse File
                                  <input
                                    type="file"
                                    id="files"
                                    title=" "
                                    name="fileName"
                                    style={{ marginRight: 40 }}
                                    multiple
                                    onChange={this.fileSelectedHandler}
                                  />
                                </span>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="No file chosen"
                                value={this.state.files}
                              />
                              {this.state.files ? (
                                <div
                                  class="input-group-append"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.ClearInputs()}
                                  ></i>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-4">
                            <label className="form-label"></label>
                            <br></br>
                            <div className="search-btn-col mt-3">
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.UploadDocuments()}
                              >
                                {" "}
                                Upload{" "}
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* <div className={"col-sm-12"}>
                                                    {this.renderHistoryCard()}
                                                </div> */}
                        {getAttachmentsDetail &&
                        getAttachmentsDetail.length !== 0 ? (
                          <div className="col-lg-12">
                            <Lightbox
                              images={getAttachmentsDetail}
                              imgDelete={(e) => this.DeleteDocuments(e)}
                            />
                          </div>
                        ) : (
                          <div className="col-lg-12 mt-3">
                            <div
                              className="card"
                              style={{
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                  No Hazardous Materials
                                </h6>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* [
                                                             {
                                                                src: 'https://unsplash.it/800/300?image=1',
                                                                title: 'image title',
                                                                description: 'image description'
                                                            },
                                                            {
                                                                src: 'https://unsplash.it/800/300?image=2',
                                                                title: 'image title',
                                                                description: 'image description'
                                                            },
                                                            {
                                                                src: 'https://unsplash.it/800/300?image=3',
                                                                title: 'image title',
                                                                description: 'image description'
                                                            }
                                                        ] */}
                      </div>

                      <div className="row mb-2">
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-4">
                            <label className="form-label">Upload File : </label>
                            <br></br>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  Browse File
                                  <input
                                    type="file"
                                    style={{ marginRight: 40 }}
                                    id="files"
                                    multiple
                                    name="fileName"
                                    onChange={this.fileSelectedHandlers}
                                  />
                                </span>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="No file chosen"
                                value={this.state.filesPDF}
                              />
                              {this.state.filesPDF ? (
                                <div
                                  class="input-group-append"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.ClearInputsPDF()}
                                  ></i>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-2">
                            <label className="form-label"></label>
                            <br></br>
                            <div className="search-btn-col mt-3">
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.UploadDocumentsPDF()}
                              >
                                {" "}
                                Upload{" "}
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="col-sm-12 mt-2">
                          <span>
                            <strong>Download : </strong>
                            {getAttachmentsPDFDetail &&
                              getAttachmentsPDFDetail.map((item, index) => {
                                return (
                                  <span class="italicFont ">
                                    {item.attachmentName}
                                    {item && item.attachmentName ? (
                                      <>
                                        <i
                                          class="fa fa-download click ml-1"
                                          onClick={() =>
                                            this.downloadDocument(item)
                                          }
                                        ></i>
                                        <a
                                          href={item?.fileUrl}
                                          target="_blank"
                                          className="link-colors pl-2"
                                        >
                                          <i class="fa fa-eye click ml-2"></i>
                                        </a>

                                        {user1 === "admin" ||
                                        user1 === "mmpl" ? (
                                          <i
                                            class="fa fa-trash click ml-2"
                                            onClick={() =>
                                              this.DeleteDocuments(
                                                item.attachmentId
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                        {getAttachmentsPDFDetail.length ===
                                        1 ? (
                                          ""
                                        ) : getAttachmentsPDFDetail.length ===
                                          index + 1 ? (
                                          ""
                                        ) : (
                                          <strong>, </strong>
                                        )}
                                      </>
                                    ) : null}
                                  </span>
                                );
                              })}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.toggleVisibilities}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {!this.state.isInventory ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                      Inventory of Hazardous Materials
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="search-filter-box mt-1">
                            <div
                              className=" card MM-card-header mb-0"
                              style={{ backgroundColor: "white" }}
                            >
                              <div
                                className="card-body"
                                style={{
                                  padding: "0rem",
                                  backgroundColor: "#1E3A8A",
                                  color: "white",
                                }}
                              >
                                <h5
                                  className="card-title m-2"
                                  style={{ color: "092a51" }}
                                >
                                  {" "}
                                  Paint & Coating Systems
                                </h5>
                              </div>
                              <div
                                className="history-box pt-3 search-filter-box"
                                style={{ maxHeight: "360px" }}
                              >
                                {PaintCoating && PaintCoating.length > 0 ? (
                                  PaintCoating.map((item) => (
                                    <div
                                      className="card MM-card-content click"
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="p-3">
                                        <div className="resource-list-auth-date">
                                          <div className="row">
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Name : </strong>
                                                {item.name}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Application : </strong>
                                                {item.application}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Location : </strong>
                                                {item.location}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Materials : </strong>
                                                {item.material}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Quantity : </strong>
                                                {item.quantity}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Unit : </strong>
                                                {item.unit}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>PCHM / CHM : </strong>
                                                {item.pchmchm}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-12 py-1">
                                              <span>
                                                <strong>Remarks : </strong>
                                                {item.remarks}{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    className="card"
                                    style={{
                                      overflow: "hidden",
                                      position: "relative",
                                    }}
                                  >
                                    <div class="container">
                                      <h6 className="resource-list-title no-item-card">
                                        !-- No items to Display --!
                                      </h6>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className="card-body"
                                style={{
                                  padding: "0rem",
                                  backgroundColor: "#1E3A8A",
                                  color: "white",
                                }}
                              >
                                <h5
                                  className="card-title m-2"
                                  style={{ color: "092a51" }}
                                >
                                  {" "}
                                  Equipment & Machinery{" "}
                                </h5>
                              </div>
                              <div
                                className="history-box pt-3 search-filter-box"
                                style={{ maxHeight: "360px" }}
                              >
                                {EquipmentMachinery &&
                                EquipmentMachinery.length > 0 ? (
                                  EquipmentMachinery.map((item) => (
                                    <div
                                      className="card MM-card-content click"
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="p-3">
                                        <div className="resource-list-auth-date">
                                          <div className="row">
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Name : </strong>
                                                {item.name}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Material : </strong>
                                                {item.material}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Location : </strong>
                                                {item.location}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Parts : </strong>
                                                {item.parts}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Quantity : </strong>
                                                {item.quantity}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Unit : </strong>
                                                {item.unit}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>PCHM / CHM : </strong>
                                                {item.pchmchm}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-12 py-1">
                                              <span>
                                                <strong>Remarks : </strong>
                                                {item.remarks}{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    className="card"
                                    style={{
                                      overflow: "hidden",
                                      position: "relative",
                                    }}
                                  >
                                    <div class="container">
                                      <h6 className="resource-list-title no-item-card">
                                        !-- No items to Display --!
                                      </h6>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className="card-body"
                                style={{
                                  padding: "0rem",
                                  backgroundColor: "#1E3A8A",
                                  color: "white",
                                }}
                              >
                                <h5
                                  className="card-title m-2"
                                  style={{ color: "092a51" }}
                                >
                                  {" "}
                                  Structure & Hull{" "}
                                </h5>
                              </div>
                              <div
                                className="history-box pt-3 search-filter-box"
                                style={{ maxHeight: "360px" }}
                              >
                                {StructureAndHull &&
                                StructureAndHull.length > 0 ? (
                                  StructureAndHull.map((item) => (
                                    <div
                                      className="card MM-card-content click"
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="p-3">
                                        <div className="resource-list-auth-date">
                                          <div className="row">
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Name : </strong>
                                                {item.name}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Material : </strong>
                                                {item.material}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Location : </strong>
                                                {item.location}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Parts : </strong>
                                                {item.parts}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Quantity : </strong>
                                                {item.quantity}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Unit : </strong>
                                                {item.unit}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>PCHM / CHM : </strong>
                                                {item.pchmchm}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-12 py-1">
                                              <span>
                                                <strong>Remarks : </strong>
                                                {item.remarks}{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    className="card"
                                    style={{
                                      overflow: "hidden",
                                      position: "relative",
                                    }}
                                  >
                                    <div class="container">
                                      <h6 className="resource-list-title no-item-card">
                                        !-- No items to Display --!
                                      </h6>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className="card-body"
                                style={{
                                  padding: "0rem",
                                  backgroundColor: "#1E3A8A",
                                  color: "white",
                                }}
                              >
                                <h5
                                  className="card-title m-2"
                                  style={{ color: "092a51" }}
                                >
                                  {" "}
                                  Stores{" "}
                                </h5>
                              </div>
                              <div
                                className="history-box pt-3 search-filter-box"
                                style={{ maxHeight: "360px" }}
                              >
                                {Store && Store.length > 0 ? (
                                  Store.map((item) => (
                                    <div
                                      className="card MM-card-content click"
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="p-3">
                                        <div className="resource-list-auth-date">
                                          <div className="row">
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Name : </strong>
                                                {item.name}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Material : </strong>
                                                {item.material}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Location : </strong>
                                                {item.location}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Parts : </strong>
                                                {item.parts}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Quantity : </strong>
                                                {item.quantity}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>Unit : </strong>
                                                {item.unit}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 py-1">
                                              <span>
                                                <strong>PCHM / CHM : </strong>
                                                {item.pchmchm}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-12 py-1">
                                              <span>
                                                <strong>Remarks : </strong>
                                                {item.remarks}{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    className="card"
                                    style={{
                                      overflow: "hidden",
                                      position: "relative",
                                    }}
                                  >
                                    <div class="container">
                                      <h6 className="resource-list-title no-item-card">
                                        !-- No items to Display --!
                                      </h6>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.lrToggleVisibility}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {!this.state.isLR ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                      LR Form
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                      <div className="row my-2">
                        <div className="col-sm-12 mb-2">
                          <span>
                            <strong>Documents : </strong>
                            {LRForm?.isApplicable === true ? (
                              <>
                                {LRForm?.isUpdated === true ? (
                                  <span class="italicFont ">
                                    {LRForm ? LRForm?.attachmentName : ""}
                                    {LRForm && LRForm?.attachmentName ? (
                                      <>
                                        <i
                                          class="fa fa-download click ml-1"
                                          onClick={() =>
                                            this.downloadLRFromDocument(LRForm)
                                          }
                                        ></i>
                                        <a
                                          href={LRForm?.fileUrl}
                                          target="_blank"
                                          className="link-colors pl-2"
                                        >
                                          <i class="fa fa-eye click ml-1"></i>
                                        </a>

                                        {/* {user1 === 'admin' || user1 === 'mmpl' ? <i class="fa fa-trash click ml-1" onClick={() => this.deleteRevisionDocument(IHMFullManual.latestUpdated)}></i> : ""} */}
                                      </>
                                    ) : null}
                                  </span>
                                ) : (
                                  <span class="italicFont ">
                                    {LRFormPDF ? LRFormPDF?.FileName : ""}
                                    {LRFormPDF && LRFormPDF?.FileName ? (
                                      <>
                                        <i
                                          class="fa fa-download click ml-1"
                                          onClick={() =>
                                            this.downloadLRDocument(LRFormPDF)
                                          }
                                        ></i>
                                        <a
                                          href={LRFormPDF?.FileUrl}
                                          target="_blank"
                                          className="link-colors pl-2"
                                        >
                                          <i class="fa fa-eye click ml-1"></i>
                                        </a>

                                        {/* {user1 === 'admin' || user1 === 'mmpl' ? <i class="fa fa-trash click ml-1" onClick={() => this.deleteRevisionDocument(IHMFullManual.latestUpdated)}></i> : ""} */}
                                      </>
                                    ) : null}
                                  </span>
                                )}
                              </>
                            ) : (
                              <span>Not Applicable</span>
                            )}
                          </span>
                        </div>
                        {LRForm?.isApplicable === true ? (
                          <>
                            {user1 === "admin" || user1 === "mmpl" ? (
                              <div className="col-lg-4">
                                <label className="form-label">
                                  Upload LR Form :{" "}
                                </label>
                                <br></br>
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      Browse File
                                      <input
                                        type="file"
                                        style={{ marginRight: 40 }}
                                        id="files"
                                        name="LrfileName"
                                        onChange={(e) =>
                                          this.handleInputChange(e)
                                        }
                                        onClick={(event) => {
                                          event.currentTarget.value = null;
                                        }}
                                      />
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="No file chosen"
                                    value={
                                      this.state.LRFromUpdate.attachmentName
                                    }
                                  />
                                  {this.state.LRFromUpdate.attachmentName ? (
                                    <div
                                      class="input-group-append"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i
                                        class="fa fa-times input-group-text"
                                        aria-hidden="true"
                                        onClick={() => this.ClearLRInput()}
                                      ></i>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                        {LRForm?.isApplicable === true ? (
                          <>
                            {user1 === "admin" || user1 === "mmpl" ? (
                              <div className="col-lg-4">
                                <label className="form-label"></label>
                                <br></br>
                                <div className="search-btn-col mt-3">
                                  <button
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    type="submit"
                                    onClick={() => this.UploadLRFromDocument()}
                                  >
                                    {" "}
                                    Upload{" "}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", marginBottom: 0 }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Latest Updated Part 1 IHM Maintenance
                  </h5>
                </div>
              </div>
              <div className="py-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-sm-12"}>
                      <div className="row mx-2 my-2">
                        <div className="col-sm-3">
                          <span>
                            <strong>Rev. No : </strong>
                            <span className="lato">
                              {IHMFullManual?.latestUpdated?.revNo > 0
                                ? IHMFullManual.latestUpdated.revNo
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-4">
                          <span>
                            <strong>Date of Revision : </strong>
                            <span className="lato">
                              {IHMFullManual?.latestUpdated?.revisionDate
                                ? Moment(
                                    new Date(
                                      Date.parse(
                                        IHMFullManual.latestUpdated.revisionDate
                                      )
                                    )
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-5 mb-2">
                          <span>
                            <strong>Download : </strong>
                            <span class="italicFont ">
                              {IHMFullManual.latestUpdated
                                ? IHMFullManual.latestUpdated.attachmentName
                                : ""}
                              {IHMFullManual.latestUpdated &&
                              IHMFullManual.latestUpdated.attachmentName ? (
                                <>
                                  <i
                                    class="fa fa-download click ml-1"
                                    onClick={() =>
                                      this.downloadDocument(
                                        IHMFullManual.latestUpdated
                                      )
                                    }
                                  ></i>
                                  <a
                                    href={IHMFullManual?.latestUpdated?.fileUrl}
                                    target="_blank"
                                    className="link-colors"
                                  >
                                    <i class="fa fa-eye click ml-2"></i>
                                  </a>

                                  {user1 === "admin" || user1 === "mmpl" ? (
                                    <i
                                      class="fa fa-trash click ml-2"
                                      onClick={() =>
                                        this.deleteRevisionDocument(
                                          IHMFullManual.latestUpdated
                                        )
                                      }
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : null}
                            </span>
                          </span>
                        </div>
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-4">
                            <label className="form-label">
                              Upload Revision Document :{" "}
                            </label>
                            <br></br>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  Browse File
                                  <input
                                    type="file"
                                    style={{ marginRight: 40 }}
                                    id="files"
                                    name="fileName"
                                    onChange={(e) => this.handleInputChange(e)}
                                    onClick={(event) => {
                                      event.currentTarget.value = null;
                                    }}
                                  />
                                </span>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="No file chosen"
                                value={this.state.RevisionUpdate.attachmentName}
                              />
                              {this.state.RevisionUpdate.attachmentName ? (
                                <div
                                  class="input-group-append"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.ClearInput()}
                                  ></i>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {user1 === "admin" || user1 === "mmpl" ? (
                          <div className="col-lg-4">
                            <label className="form-label"></label>
                            <br></br>
                            <div className="search-btn-col mt-3">
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.UploadDocument()}
                              >
                                {" "}
                                Upload{" "}
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <div className="row">
                    <Accordion.Toggle
                      as={Card.Body}
                      eventKey="0"
                      className="col-lg-12 "
                      style={{ cursor: "pointer" }}
                      onClick={this.toggleVisibility}
                    >
                      <h5
                        className="card-title ml-2 mt-2 pl-3"
                        style={{ color: "092a51" }}
                      >
                        {!this.state.isActive ? (
                          <i
                            className="fa fa-plus mr-1"
                            aria-hidden="true"
                            style={{ color: "#fff", fontSize: "1.1rem" }}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-minus mr-1"
                            aria-hidden="true"
                            style={{ color: "#fff", fontSize: "1.1rem" }}
                          ></i>
                        )}{" "}
                        IHM Part I Maintenance Revision History
                      </h5>
                    </Accordion.Toggle>
                    {/* <i className="fa fa-download click col-lg-1 pt-2 App" style={{ backgroundColor: "#1E3A8A", color:"white", fontSize: "25px"}} onClick={() => this.downloadRevisionDocument("Nord Colorado - Revision History of Procedure.pdf", "b279a192d2af4c3baa9956faab566c72")}></i> */}
                  </div>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                      <div className="row">
                        <div className={"col-sm-12"}>
                          {this.renderHistoryCard()}
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.IHMToggleVisibility}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {!this.state.isIHMReport ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                      IHM Maintenance Record
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                      {/* <div className="col-sm-12 mb-1">
                        <span>
                          <strong>Download : </strong>
                          <span class="italicFont ">
                            {ShipDetail && ShipDetail.shipName + ".pdf"}

                            <i
                              class="fa fa-download click ml-1"
                              onClick={() =>
                                this.DownloadReport(ShipDetail.shipName)
                              }
                            ></i>
                          </span>
                        </span>
                      </div> */}
                      <div className="col-12 pb-3">
                        <div className="row">
                          <div className="col-lg-3">
                            <label className="form-label">From Date</label>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.searchData.minyear}
                                className="form-control date-picker required"
                                placeholder="From Date"
                                disabled={this.state.isAll ? true : false}
                                name="POFromDate"
                              ></input>
                              <DatePicker
                                onChange={(date) => {
                                  this.handleFromToChange(date, "minyear");
                                }}
                                maxDate={
                                  this.state.searchData.maxyear
                                    ? new Date(this.state.searchData.maxyear)
                                    : null
                                }
                                disabled={this.state.isAll ? true : false}
                                open={
                                  this.state.isAll
                                    ? false
                                    : this.state.isFromOpen
                                }
                                portalId="datepicker-portal"
                                onClickOutside={() => {
                                  this.setState({
                                    isToOpen: false,
                                    isFromOpen: false,
                                  });
                                }}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={() => {
                                  if (!this.state.isAll) {
                                    this.setState({ isFromOpen: true });
                                  }
                                }}
                              >
                                <button
                                  className="btn btn-default"
                                  style={{ height: "100%" }}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <label className="form-label ">To Date</label>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.searchData.maxyear}
                                className="form-control date-picker required"
                                placeholder="To Date"
                                name="POFromDate"
                                disabled={this.state.isAll ? true : false}
                              ></input>
                              <DatePicker
                                // selected={this.state.SelectedFromDate}
                                minDate={
                                  this.state.searchData.minyear
                                    ? new Date(this.state.searchData.minyear)
                                    : null
                                }
                                onChange={(date) => {
                                  this.handleFromToChange(date, "maxyear");
                                }}
                                disabled={this.state.isAll ? true : false}
                                open={
                                  this.state.isAll ? false : this.state.isToOpen
                                }
                                portalId="datepicker-portal"
                                onClickOutside={() => {
                                  this.setState({
                                    isToOpen: false,
                                    isFromOpen: false,
                                  });
                                }}
                                // readOnly={this.state.isAll?true:false}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={() => {
                                  if (!this.state.isAll) {
                                    this.setState({ isToOpen: true });
                                  }
                                }}
                              >
                                <button
                                  className="btn btn-default"
                                  style={{ height: "100%" }}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-auto">
                            <label className="form-label"></label>
                            <br></br>
                            <div className="d-flex align-items-center " style={{marginTop:'13.5px'}}>
                              <input
                                type="checkbox"
                                onChange={this.isAllCheck}
                                checked={this.state.isAll}
                                style={{ height: 17, width: 17 }}
                              ></input>
                              <label className="form-label ml-2">Is All</label>
                            </div>
                          </div>
                          <div className="col-lg-3 mt-0 mt-lg-3">
                            <label className="form-label"></label>
                            <br></br>
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() =>
                                this.DownloadReport(ShipDetail.shipName)
                              }
                            >
                              {" "}
                              Download{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHistoryCard() {
    const { RevisionHistory } = this.props;
    return RevisionHistory && RevisionHistory.length ? (
      RevisionHistory.map((item, index) => {
        return (
          <>
            <div
              className="card MM-card-content"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-3">
                      <span>
                        <strong>Rev. No : </strong>
                        <span className="italicFont ">{item.revNo}</span>
                      </span>
                    </div>
                    <div className="col-sm-4">
                      <span>
                        <strong>Date of Revision : </strong>
                        <span className="italicFont ">
                          {" "}
                          {Moment(
                            new Date(Date.parse(item.revisionDate))
                          ).format("DD MMM YYYY")}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-5">
                      <span>
                        <strong>Download : </strong>
                        <span className="italicFont ">
                          {item.attachmentName}
                        </span>
                        {item.attachmentName ? (
                          <>
                            <i
                              className="fa fa-download click ml-2"
                              onClick={() => this.downloadDocument(item)}
                            ></i>
                            <a
                              href={item?.fileUrl}
                              target="_blank"
                              className="link-colors pl-2"
                            >
                              <i class="fa fa-eye click ml-1"></i>
                            </a>
                          </>
                        ) : null}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            No Revision History
          </h6>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    //BY BALU MOORTHI
    IHMFullManual: state.ShipViewReducer.IHMFullManual || {},
    UpdatedIHMMaintenance: state.ShipViewReducer.UpdatedIHMMaintenance,
    RevisionHistory: state.ShipViewReducer.RevisionHistory || [],
    attachmentDetail: state.ShipViewReducer.attachmentDetail,
    attachmentLRDetail: state.ShipViewReducer.attachmentLRDetail,
    attachmentsDetail: state.ShipViewReducer.attachmentsDetail,
    getAttachmentsDetail: state.ShipViewReducer.getAttachmentsDetail || null,
    getAttachmentsPDFDetail:
      state.ShipViewReducer.getAttachmentsPDFDetail || null,
    Role: state.SidePanReducer.UserRole || null,
    PaintCoating: state.MMPLDashboardReducer.PaintCoating || [],
    EquipmentMachinery: state.MMPLDashboardReducer.EquipmentMachinery || [],
    StructureAndHull: state.MMPLDashboardReducer.StructureAndHull || [],
    Store: state.MMPLDashboardReducer.Store || [],
    LRForm: state.MasterScreenReducer.LRForm,
    LRFormPDF: state.MasterScreenReducer.LRFormPDF,
    ShipDetail: state.ShipViewReducer.ShipDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IHMMaintenanceRevision);
